import * as Yup from 'yup';
import { phoneNumberIsValid } from '../utils';

const phoneSchema = Yup.object().shape({
  phone: Yup.string()
    .trim()
    .required('Please enter your phone\u00A0number.')
    .test(
      'test-phone',
      'Please enter a valid phone\u00A0number.',
      phoneNumberIsValid
    )
});

export { phoneSchema };
